/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 *
 * Open source under the BSD License.
 *
 * Copyright Â© 2008 George McGinley Smith
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
*/

// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend( jQuery.easing,
{
	def: 'easeOutQuad',
	swing: function (x, t, b, c, d) {
		//alert(jQuery.easing.default);
		return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
	},
	easeInQuad: function (x, t, b, c, d) {
		return c*(t/=d)*t + b;
	},
	easeOutQuad: function (x, t, b, c, d) {
		return -c *(t/=d)*(t-2) + b;
	},
	easeInOutQuad: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t + b;
		return -c/2 * ((--t)*(t-2) - 1) + b;
	},
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutCubic: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t + 1) + b;
	},
	easeInOutCubic: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t + b;
		return c/2*((t-=2)*t*t + 2) + b;
	},
	easeInQuart: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t + b;
	},
	easeOutQuart: function (x, t, b, c, d) {
		return -c * ((t=t/d-1)*t*t*t - 1) + b;
	},
	easeInOutQuart: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
		return -c/2 * ((t-=2)*t*t*t - 2) + b;
	},
	easeInQuint: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t*t + b;
	},
	easeOutQuint: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t*t*t + 1) + b;
	},
	easeInOutQuint: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
		return c/2*((t-=2)*t*t*t*t + 2) + b;
	},
	easeInSine: function (x, t, b, c, d) {
		return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
	},
	easeOutSine: function (x, t, b, c, d) {
		return c * Math.sin(t/d * (Math.PI/2)) + b;
	},
	easeInOutSine: function (x, t, b, c, d) {
		return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
	},
	easeInExpo: function (x, t, b, c, d) {
		return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
	},
	easeOutExpo: function (x, t, b, c, d) {
		return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	},
	easeInOutExpo: function (x, t, b, c, d) {
		if (t==0) return b;
		if (t==d) return b+c;
		if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
		return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
	},
	easeInCirc: function (x, t, b, c, d) {
		return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
	},
	easeOutCirc: function (x, t, b, c, d) {
		return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
	},
	easeInOutCirc: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
		return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
	},
	easeInElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
	},
	easeOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
	},
	easeInOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
	},
	easeInBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*(t/=d)*t*((s+1)*t - s) + b;
	},
	easeOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	},
	easeInOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
		return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
	},
	easeInBounce: function (x, t, b, c, d) {
		return c - jQuery.easing.easeOutBounce (x, d-t, 0, c, d) + b;
	},
	easeOutBounce: function (x, t, b, c, d) {
		if ((t/=d) < (1/2.75)) {
			return c*(7.5625*t*t) + b;
		} else if (t < (2/2.75)) {
			return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
		} else if (t < (2.5/2.75)) {
			return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
		} else {
			return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
		}
	},
	easeInOutBounce: function (x, t, b, c, d) {
		if (t < d/2) return jQuery.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
		return jQuery.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
	}
});

/*
 *
 * TERMS OF USE - EASING EQUATIONS
 *
 * Open source under the BSD License.
 *
 * Copyright Â© 2001 Robert Penner
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */

/*!
 * jQuery.ScrollTo
 * Copyright (c) 2007-2012 Ariel Flesler - aflesler(at)gmail(dot)com | http://flesler.blogspot.com
 * Dual licensed under MIT and GPL.
 * Date: 4/09/2012
 *
 * @projectDescription Easy element scrolling using jQuery.
 * http://flesler.blogspot.com/2007/10/jqueryscrollto.html
 * @author Ariel Flesler
 * @version 1.4.3.1
 *
 * @id jQuery.scrollTo
 * @id jQuery.fn.scrollTo
 * @param {String, Number, DOMElement, jQuery, Object} target Where to scroll the matched elements.
 *	  The different options for target are:
 *		- A number position (will be applied to all axes).
 *		- A string position ('44', '100px', '+=90', etc ) will be applied to all axes
 *		- A jQuery/DOM element ( logically, child of the element to scroll )
 *		- A string selector, that will be relative to the element to scroll ( 'li:eq(2)', etc )
 *		- A hash { top:x, left:y }, x and y can be any kind of number/string like above.
 *		- A percentage of the container's dimension/s, for example: 50% to go to the middle.
 *		- The string 'max' for go-to-end.
 * @param {Number, Function} duration The OVERALL length of the animation, this argument can be the settings object instead.
 * @param {Object,Function} settings Optional set of settings or the onAfter callback.
 *	 @option {String} axis Which axis must be scrolled, use 'x', 'y', 'xy' or 'yx'.
 *	 @option {Number, Function} duration The OVERALL length of the animation.
 *	 @option {String} easing The easing method for the animation.
 *	 @option {Boolean} margin If true, the margin of the target element will be deducted from the final position.
 *	 @option {Object, Number} offset Add/deduct from the end position. One number for both axes or { top:x, left:y }.
 *	 @option {Object, Number} over Add/deduct the height/width multiplied by 'over', can be { top:x, left:y } when using both axes.
 *	 @option {Boolean} queue If true, and both axis are given, the 2nd axis will only be animated after the first one ends.
 *	 @option {Function} onAfter Function to be called after the scrolling ends.
 *	 @option {Function} onAfterFirst If queuing is activated, this function will be called after the first scrolling ends.
 * @return {jQuery} Returns the same jQuery object, for chaining.
 *
 * @desc Scroll to a fixed position
 * @example $('div').scrollTo( 340 );
 *
 * @desc Scroll relatively to the actual position
 * @example $('div').scrollTo( '+=340px', { axis:'y' } );
 *
 * @desc Scroll using a selector (relative to the scrolled element)
 * @example $('div').scrollTo( 'p.paragraph:eq(2)', 500, { easing:'swing', queue:true, axis:'xy' } );
 *
 * @desc Scroll to a DOM element (same for jQuery object)
 * @example var second_child = document.getElementById('container').firstChild.nextSibling;
 *			$('#container').scrollTo( second_child, { duration:500, axis:'x', onAfter:function(){
 *				alert('scrolled!!');
 *			}});
 *
 * @desc Scroll on both axes, to different values
 * @example $('div').scrollTo( { top: 300, left:'+=200' }, { axis:'xy', offset:-20 } );
 */

;(function( $ ){

	var $scrollTo = $.scrollTo = function( target, duration, settings ){
		$(window).scrollTo( target, duration, settings );
	};

	$scrollTo.defaults = {
		axis:'xy',
		duration: parseFloat($.fn.jquery) >= 1.3 ? 0 : 1,
		limit:true
	};

	// Returns the element that needs to be animated to scroll the window.
	// Kept for backwards compatibility (specially for localScroll & serialScroll)
	$scrollTo.window = function( scope ){
		return $(window)._scrollable();
	};

	// Hack, hack, hack :)
	// Returns the real elements to scroll (supports window/iframes, documents and regular nodes)
	$.fn._scrollable = function(){
		return this.map(function(){
			var elem = this,
				isWin = !elem.nodeName || $.inArray( elem.nodeName.toLowerCase(), ['iframe','#document','html','body'] ) != -1;

				if( !isWin )
					return elem;

			var doc = (elem.contentWindow || elem).document || elem.ownerDocument || elem;

			return /webkit/i.test(navigator.userAgent) || doc.compatMode == 'BackCompat' ?
				doc.body :
				doc.documentElement;
		});
	};

	$.fn.scrollTo = function( target, duration, settings ){
		if( typeof duration == 'object' ){
			settings = duration;
			duration = 0;
		}
		if( typeof settings == 'function' )
			settings = { onAfter:settings };

		if( target == 'max' )
			target = 9e9;

		settings = $.extend( {}, $scrollTo.defaults, settings );
		// Speed is still recognized for backwards compatibility
		duration = duration || settings.duration;
		// Make sure the settings are given right
		settings.queue = settings.queue && settings.axis.length > 1;

		if( settings.queue )
			// Let's keep the overall duration
			duration /= 2;
		settings.offset = both( settings.offset );
		settings.over = both( settings.over );

		return this._scrollable().each(function(){
			// Null target yields nothing, just like jQuery does
			if (target == null) return;

			var elem = this,
				$elem = $(elem),
				targ = target, toff, attr = {},
				win = $elem.is('html,body');

			switch( typeof targ ){
				// A number will pass the regex
				case 'number':
				case 'string':
					if( /^([+-]=)?\d+(\.\d+)?(px|%)?$/.test(targ) ){
						targ = both( targ );
						// We are done
						break;
					}
					// Relative selector, no break!
					targ = $(targ,this);
					if (!targ.length) return;
				case 'object':
					// DOMElement / jQuery
					if( targ.is || targ.style )
						// Get the real position of the target
						toff = (targ = $(targ)).offset();
			}
			$.each( settings.axis.split(''), function( i, axis ){
				var Pos	= axis == 'x' ? 'Left' : 'Top',
					pos = Pos.toLowerCase(),
					key = 'scroll' + Pos,
					old = elem[key],
					max = $scrollTo.max(elem, axis);

				if( toff ){// jQuery / DOMElement
					attr[key] = toff[pos] + ( win ? 0 : old - $elem.offset()[pos] );

					// If it's a dom element, reduce the margin
					if( settings.margin ){
						attr[key] -= parseInt(targ.css('margin'+Pos)) || 0;
						attr[key] -= parseInt(targ.css('border'+Pos+'Width')) || 0;
					}

					attr[key] += settings.offset[pos] || 0;

					if( settings.over[pos] )
						// Scroll to a fraction of its width/height
						attr[key] += targ[axis=='x'?'width':'height']() * settings.over[pos];
				}else{
					var val = targ[pos];
					// Handle percentage values
					attr[key] = val.slice && val.slice(-1) == '%' ?
						parseFloat(val) / 100 * max
						: val;
				}

				// Number or 'number'
				if( settings.limit && /^\d+$/.test(attr[key]) )
					// Check the limits
					attr[key] = attr[key] <= 0 ? 0 : Math.min( attr[key], max );

				// Queueing axes
				if( !i && settings.queue ){
					// Don't waste time animating, if there's no need.
					if( old != attr[key] )
						// Intermediate animation
						animate( settings.onAfterFirst );
					// Don't animate this axis again in the next iteration.
					delete attr[key];
				}
			});

			animate( settings.onAfter );

			function animate( callback ){
				$elem.animate( attr, duration, settings.easing, callback && function(){
					callback.call(this, target, settings);
				});
			};

		}).end();
	};

	// Max scrolling position, works on quirks mode
	// It only fails (not too badly) on IE, quirks mode.
	$scrollTo.max = function( elem, axis ){
		var Dim = axis == 'x' ? 'Width' : 'Height',
			scroll = 'scroll'+Dim;

		if( !$(elem).is('html,body') )
			return elem[scroll] - $(elem)[Dim.toLowerCase()]();

		var size = 'client' + Dim,
			html = elem.ownerDocument.documentElement,
			body = elem.ownerDocument.body;

		return Math.max( html[scroll], body[scroll] )
			 - Math.min( html[size]  , body[size]   );
	};

	function both( val ){
		return typeof val == 'object' ? val : { top:val, left:val };
	};

})( jQuery );

$(window).on("load", function()
{
	webshop.swapArtcod = function(gc1offrgl_unid, callback)
	{
		$.ajax({
			url: "/BestelServlet",
			type: "post",
			data: { "action": "swapartcod", "gc1offrgl_unid": gc1offrgl_unid },
			success: function(xmlDoc, textStatus, jqXHR)
			{
				if (callback)								{ callback(xmlDoc); }
			}
		});
	};

	webshop.setLengte = function(gc1offrgl_unid, value, callback)
	{
		$.ajax({
			url: "/BestelServlet",
			type: "post",
			data: { "action": "setlengte", "gc1offrgl_unid": gc1offrgl_unid, "lengte": value < 5 ? 0 : value /* Ticket 195555 */ },
			success: function(xmlDoc, textStatus, jqXHR)
			{
				if (callback)								{ callback(xmlDoc); }
			}
		});
	};

	webshop.setLandcod = function(landcod, callback)
	{
		$.ajax({
			url: "/BestelServlet",
			type: "post",
			data: { "action": "setlandcod", "landcod": landcod },
			success: function(xmlDoc, textStatus, jqXHR)
			{
				if (callback)								{ callback(xmlDoc); }
			}
		});
	};

	var minicartCounter										= 0;

	webshop.reloadMinicart = function()
	{
		var c												= ++minicartCounter;
		$.ajax({
			url: "/minicart",
			type: "get",
			cache: false,
			success: function(xmlDoc, textStatus, jqXHR)
			{
				if (c == minicartCounter)					{ $("#minicart").html($(xmlDoc).html()); }
			}
		});
	}
});

(function ($)
{
	$(window).load(function() {
		jQuery("#preloader").delay(100).fadeOut("slow");
		jQuery("#load").delay(100).fadeOut("slow");

		$(".navbar .navbar-brand").css("cursor", "pointer");
	});

	//jQuery for page scrolling feature - requires jQuery Easing plugin
	$(function()
	{
		$(".navbar-nav li a").bind("click", function(event)
		{
			var $anchor = $(this);

			if ($anchor.attr("href") && $anchor.attr("href").startsWith("#") && $anchor.attr("href") != "#")
			{
				$("html, body").stop().animate({ scrollTop: $($anchor.attr("href")).offset().top }, 1500, "easeInOutExpo");
				event.preventDefault();
			}
		});

		$(".page-scroll a").bind("click", function(event)
		{
			var $anchor = $(this);

			if ($anchor.attr("href") && $anchor.attr("href").startsWith("#") && $anchor.attr("href") != "#")
			{
				$("html, body").stop().animate({ scrollTop: $($anchor.attr("href")).offset().top }, 1500, "easeInOutExpo");
				event.preventDefault();
			}
		});
	});
})(jQuery);

$(document).on("ready", function()
{
	$(".carousel-area").each(function()
	{
		$(this).html($(this).find("> div.area").html());
		$(this).find("> div.item").first().addClass("active");

		var total = $(this).find("> div.item").length;

		for (var i = 0; i < total; i = i + 1)
		{
			$(this).parent().find(".carousel-indicators").append("<li data-target=\"#" + $(this).parents(".carousel").first().attr("id") + "\" data-slide-to=\"" + i + "\"" + (i == 0 ? " class=\"active\"" : "") + "></li>");
		}
	});

	$(".checkboxgroupc").each(function()
	{
		var elem					= $("<div class=\"checkboxgroupdiv\" onselectstart=\"return false;\"></div>");

		elem.insertAfter(this);

		elem.append("<span class=\"title\">" + $(this).find("label").first().text() + "</span><i class=\"fas fa-chevron-down\"></i>");
		elem.append(this);

		var listElem				= $("<ul style=\"display: none;\"></ul>");

		elem.append(listElem);

		var url;

		$(this).find(".checkboxgroup").each(function()
		{
			url						= $(".colorTile[data-artcod='" + $(this).val() + "']").find(".image").css("background-image");

			if (!url)				{ url = $(".colorTile[data-artcod='" + $(this).val().replace(/FM95/g, "FM93") + "']").find(".image").css("background-image"); }

			if (url)				{ listElem.append($("<li></li>").attr("style", "background-image:" + url + ";").append(this).append($("label[for='" + this.id.replace("*", "\\*") + "']"))); }
			else					{ listElem.append($("<li></li>").append(this).append($("label[for='" + this.id.replace("*", "\\*") + "']"))); }
		});

		elem.on("click", function(e)
		{
			if ($(e.target).is(".checkboxgroupdiv, .checkboxgroupdiv > .title, .checkboxgroupdiv > i"))
			{
				if ($(this).find("> ul").is(":visible"))
				{
					$(this).find("> ul").slideUp();
				}
				else
				{
					$(this).find("> ul").slideDown();
				}
			}
		});

		// Can't set on body without breaking iPad support when clicking colors.
		$("section").on("click", function(e)
		{
			if (!$(e.target).is(".checkboxgroupdiv, .checkboxgroupdiv *"))
			{
				if (elem.find("> ul").is(":visible"))
				{
					elem.find("> ul").slideUp();
				}
			}
		});
	});
});

function onFormSave($form)
{
	if ($form.attr("id").startsWith("form_") && $form.data("isSaved"))
	{
		$form.find("input[type=text],input[type=email],textarea").val("");
		$form.parents("section").find(".successAlert").fadeIn();
		$form.data("isSaved", false);
		$form.data("isClosed", false);
		try { $form.find(".captcharefresh").trigger("click"); } catch (ex){}
	}
	else if ($form.attr("id") == "cart" && $form.data("isSaved"))
	{
		oldlandcod = null;

		window.location.replace("/jsp/feltmen/betalen.jsp?betcod=" + $("input[name=betcod]:checked").val());
	}
	else
	{
		throw "";
	}
}

$(document).on("ready", function()
{
	$(".zipcode,.countrycode").on("change", function()
	{
		var form = $(this.form);

		if (ui.validation.isZipcodeValid($(form).find(".zipcode").val(), $(form).find(".countrycode").val()))
		{
			$(form).find(".zipcode").attr("valid", "true").removeAttr("errmsg");
		}
		else
		{
			$(form).find(".zipcode").attr("valid", "false").attr("errmsg", "De opgegeven postcode is ongeldig.");
		}
	});
});

$(window).on("load", function()
{
	ui.dialog.alert = function(msg, callback)
	{
		if ($.trim(JSO.toString(msg)) != "")
		{
			alert(msg);
		}

		if (callback)
		{
			callback();
		}
	}
});

function addToCart(gc1art_unid, amount)
{
	webshop.addToCart(gc1art_unid, amount, function(xmlDoc)
	{
		if ($("#shoppingcart").length > 0)
		{
			try { updateCarts(); } catch (ex){}
			try { $("#shoppingcart").parent().parent()[0].scrollIntoView(); } catch (ex){}
			try { $(window).scrollTop($(window).scrollTop() - 250); } catch (ex){}
		}
	});
}

var updateCarts;

$(window).on("load", function()
{
	if ($("#shoppingcart").length > 0)
	{
		var articlesWithAlternatives = null;

		function formatMoney(n)
		{
			return accounting.formatMoney(n, "&euro;", 2, ".", ",", "%s %v")
		}

		function updateCart(xmlDoc)
		{
			webshop.reloadMinicart();

			var html = "";

			if (xmlDoc && xmlDoc["lines"] && xmlDoc["lines"].length > 0)
			{
				$(".hide-on-empty-cart").show();

				for (var i = 0; i < xmlDoc["lines"].length; i = i + 1)
				{
					html = html + "<div class=\"item\" data-verkeenh=\"" + xmlDoc["lines"][i]["verkeenh"] + "\" data-rglid=\"" + xmlDoc["lines"][i]["rglUnid"] + "\" data-artid=\"" + xmlDoc["lines"][i]["gc1ArtUnid"] + "\">";
					html = html + " <div class=\"col col-1\">";
					html = html + "  <div class=\"header\">" + $("#shoppingcart .header > .col.col-1").text() + "</div>";
					html = html + "  <div class=\"content\">";

					if (xmlDoc["lines"][i]["picSysflsUnid"] && xmlDoc["lines"][i]["picSysflsUnid"] != "0")
					{
						html = html + "   <div class=\"image\"><img src=\"/file/resize/48x48/db/" + xmlDoc["lines"][i]["picSysflsUnid"] + "\" style=\"border-radius: 4px;\" /></div>";
					}

					html = html + "   <div class=\"title\">" + xmlDoc["lines"][i]["artcod"] + "</div>";
					html = html + "  </div>";
					html = html + " </div>";

					if (xmlDoc["lines"][i]["eenhcod"])
					{
						html = html + " <div class=\"col col-2" + (xmlDoc["lines"][i]["hoogte"] ? "\"" : " hide-on-mobile\" style=\"visibility: hidden;\"") + ">";
						html = html + "  <div class=\"header\">" + $("#shoppingcart .header > .col.col-2").text() + "</div>";
						html = html + "  <div class=\"content\">";
						html = html + "   <div class=\"range\">";
						html = html + "    <span class=\"minus\"><i class=\"fas fa-minus\"></i></span>";
						html = html + "    <span class=\"value\">" + xmlDoc["lines"][i]["lengte"] + " M</span>";
						html = html + "    <span class=\"plus\"><i class=\"fas fa-plus\"></i></span>";
						html = html + "   </div>";
						html = html + "  </div>";
						html = html + " </div>";
						html = html + " <div class=\"col col-3" + (xmlDoc["lines"][i]["hoogte"] ? "\"" : " hide-on-mobile\" style=\"visibility: hidden;\"") + ">";
						html = html + "  <div class=\"header\">" + $("#shoppingcart .header > .col.col-3").text() + "</div>";
						html = html + "  <div class=\"content\">";
						html = html + "   " + (parseFloat(xmlDoc["lines"][i]["breedte"]) * 100) + " CM";
						html = html + "  </div>";
						html = html + " </div>";
						html = html + " <div class=\"col col-4" + (xmlDoc["lines"][i]["hoogte"] ? "\"" : " hide-on-mobile\" style=\"visibility: hidden;\"") + ">";
						html = html + "  <div class=\"header\">" + $("#shoppingcart .header > .col.col-4").text() + "</div>";
						html = html + "  <div class=\"content\">";

						if ($.inArray(xmlDoc["lines"][i]["artcod"], articlesWithAlternatives) > -1)
						{
							html = html + "   <div class=\"range swapartcod\">";
							html = html + "    <span class=\"minus\"><i class=\"fas fa-minus\"></i></span>";
							html = html + "    <span class=\"value\">" + xmlDoc["lines"][i]["hoogte"] + " MM</span>";
							html = html + "    <span class=\"plus\"><i class=\"fas fa-plus\"></i></span>";
							html = html + "   </div>";
						}
						else
						{
							html = html + "   <span class=\"text\">" + (xmlDoc["lines"][i]["hoogte"]) + " MM (STANDARD)</span>";
						}

						html = html + "  </div>";
						html = html + " </div>";
					}
					else
					{
						html = html + " <div class=\"col col-2 hide-on-mobile\" style=\"visibility: hidden;\">";
						html = html + "  <div class=\"header\">" + $("#shoppingcart .header > .col.col-2").text() + "</div>";
						html = html + "  <div class=\"content\">";
						html = html + "  </div>";
						html = html + " </div>";

						html = html + " <div class=\"col col-3 hide-on-mobile\" style=\"visibility: hidden;\">";
						html = html + "  <div class=\"header\">" + $("#shoppingcart .header > .col.col-3").text() + "</div>";
						html = html + "  <div class=\"content\">";
						html = html + "  </div>";
						html = html + " </div>";

						html = html + " <div class=\"col col-4" + (xmlDoc["lines"][i]["canBeDeleted"] ? "\"" : " hide-on-mobile\" style=\"visibility: hidden;\"") + ">";
						html = html + "  <div class=\"header\">" + $("#shoppingcart .amount-text").text() + "</div>";
						html = html + "  <div class=\"content\">";

						if (xmlDoc["lines"][i]["canBeDeleted"])
						{
							html = html + "   <div class=\"range\">";
							html = html + "    <span class=\"minus\"><i class=\"fas fa-minus\"></i></span>";
							html = html + "    <span class=\"value\">" + xmlDoc["lines"][i]["amount"] + "</span>";
							html = html + "    <span class=\"plus\"><i class=\"fas fa-plus\"></i></span>";
							html = html + "   </div>";
						}

						html = html + "  </div>";
						html = html + " </div>";
					}

					html = html + " <div class=\"col col-5\">";
					html = html + "  <div class=\"header\">" + $("#shoppingcart .header > .col.col-5").text() + "</div>";
					html = html + "  <div class=\"content\">";
					html = html + "   " + formatMoney((user_type == "P" ? xmlDoc["lines"][i]["lineAmountInclusiveVat"] : xmlDoc["lines"][i]["lineAmountExclusiveVat"]));

					if (xmlDoc["lines"][i]["canBeDeleted"])
					{
						html = html + "   <span class=\"remove\"><i class=\"fas fa-times\"></i></span>";
					}

					html = html + "  </div>";
					html = html + " </div>";

					if (!xmlDoc["lines"][i]["inStock"])
					{
						html = html + "  <div class=\"content\" style=\"color: #FF0000; padding: 4px 8px;\">";
						html = html + "Uw aangevraagde hoeveelheid is momenteel niet" + (xmlDoc["lines"][i]["eenhcod"] ? " (in een stuk)" : "") + " op voorraad. Mail ons via <a href=\"mailto:info@feltmen.nl\">info@feltmen.nl</a> voor meer informatie.";
						html = html + "  </div>";
					}

					html = html + "</div>";
					xmlDoc.lines[i]
				}

				if (user_type == "P")
				{
					html = html + "<div class=\"item totals\">";
					html = html + " <div class=\"col col-1 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-2 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-3 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-4 hide-on-mobile\">";
					html = html + "  <div class=\"content\">" + translate_total.toUpperCase() + "</div>";
					html = html + " </div>";
					html = html + " <div class=\"col col-5\">";
					html = html + "  <div class=\"header\">" + translate_total.toUpperCase() + "</div>";
					html = html + "  <div class=\"content\">" + formatMoney(xmlDoc["headerAmounts"]["totBedrInclBtw"]) + "</div>";
					html = html + " </div>";
					html = html + "</div>";

					html = html + "<div class=\"item totals\">";
					html = html + " <div class=\"col col-1 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-2 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-3 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-4 hide-on-mobile\">";
					html = html + "  <div class=\"content\">" + translate_subtotalexclvat.toUpperCase() + "</div>";
					html = html + " </div>";
					html = html + " <div class=\"col col-5\">";
					html = html + "  <div class=\"header\">" + translate_subtotalexclvat.toUpperCase() + "</div>";
					html = html + "  <div class=\"content\">" + formatMoney(xmlDoc["headerAmounts"]["totBedrExclBtw"]) + "</div>";
					html = html + " </div>";
					html = html + "</div>";

					html = html + "<div class=\"item totals\">";
					html = html + " <div class=\"col col-1 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-2 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-3 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-4 hide-on-mobile\">";
					html = html + "  <div class=\"content\">" + translate_vat.toUpperCase() + "</div>";
					html = html + " </div>";
					html = html + " <div class=\"col col-5\">";
					html = html + "  <div class=\"header\">" + translate_vat.toUpperCase() + "</div>";
					html = html + "  <div class=\"content\">" + formatMoney(xmlDoc["headerAmounts"]["btwBedr"]) + "</div>";
					html = html + " </div>";
					html = html + "</div>";
				}
				else
				{
					html = html + "<div class=\"item totals\">";
					html = html + " <div class=\"col col-1 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-2 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-3 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-4 hide-on-mobile\">";
					html = html + "  <div class=\"content\">" + translate_subtotal.toUpperCase() + "</div>";
					html = html + " </div>";
					html = html + " <div class=\"col col-5\">";
					html = html + "  <div class=\"header\">" + translate_subtotal.toUpperCase() + "</div>";
					html = html + "  <div class=\"content\">" + formatMoney(xmlDoc["headerAmounts"]["totBedrExclBtw"]) + "</div>";
					html = html + " </div>";
					html = html + "</div>";

					html = html + "<div class=\"item totals\">";
					html = html + " <div class=\"col col-1 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-2 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-3 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-4 hide-on-mobile\">";
					html = html + "  <div class=\"content\">" + translate_vat.toUpperCase() + "</div>";
					html = html + " </div>";
					html = html + " <div class=\"col col-5\">";
					html = html + "  <div class=\"header\">" + translate_vat.toUpperCase() + "</div>";
					html = html + "  <div class=\"content\">" + formatMoney(xmlDoc["headerAmounts"]["btwBedr"]) + "</div>";
					html = html + " </div>";
					html = html + "</div>";

					html = html + "<div class=\"item totals\">";
					html = html + " <div class=\"col col-1 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-2 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-3 hide-on-mobile\"></div>";
					html = html + " <div class=\"col col-4 hide-on-mobile\">";
					html = html + "  <div class=\"content\">" + translate_total.toUpperCase() + "</div>";
					html = html + " </div>";
					html = html + " <div class=\"col col-5\">";
					html = html + "  <div class=\"header\">" + translate_total.toUpperCase() + "</div>";
					html = html + "  <div class=\"content\">" + formatMoney(xmlDoc["headerAmounts"]["totBedrInclBtw"]) + "</div>";
					html = html + " </div>";
					html = html + "</div>";
				}
			}
			else
			{
				$(".hide-on-empty-cart").hide();

				html = html + "<div class=\"item\">";
				html = html + " <div class=\"col col-1\" style=\"width: auto; font-weight: 300;\"><div class=\"content\">Er zijn geen artikelen in uw winkelwagen.</div></div>";
				html = html + "</div>";
			}

			$("#shoppingcart > .items").html(html);

			$("#shoppingcart > .items > .item[data-rglid] .remove").on("click", function()
			{
				var itemElement							= $(this).parents(".item");

				if (!itemElement.data("updating"))
				{
					itemElement.data("updating", true);

					webshop.updateCart(itemElement.attr("data-rglid"), itemElement.attr("data-artid"), 0, function(xmlDoc)
					{
						itemElement.data("updating", false);

						if ($(xmlDoc).find("success").length > 0)
						{
							webshop.fetchCart(updateCart);
						}
					});
				}
			});

			$("#shoppingcart > .items > .item[data-rglid] .range .minus, #shoppingcart > .items > .item[data-rglid] .range .plus").on("mousedown", function()
			{
				if (!$(this).parent().hasClass("swapartcod"))
				{
					var itemElement							= $(this).parents(".item");
					var c									= itemElement.data("mouseCounter");

					if (!c)									{ itemElement.data("mouseCounter", 1); c = 1; }
					else									{ c = c + 1; itemElement.data("mouseCounter", c); }

					if (!itemElement.data("updating"))
					{
						itemElement.data("mousedown", true);

						var valueElement					= $(this).parent().find(".value");
						var text							= valueElement.text();
						var value							= parseInt(text.left(" "));
						var diff							= $(this).hasClass("plus") ? 1 : -1;

						function setValue(newValue)
						{
							value							= newValue;

							valueElement.text(value + (text.indexOf(" ") > -1 ? " " + text.right(" ") : ""));
						}

						function addValue()
						{
							if (c == itemElement.data("mouseCounter") && itemElement.data("mousedown"))
							{
								setValue(Math.max(0, value + diff));
							}
						}

						addValue();

						setTimeout(function()
						{
							itemElement.data("interval", setInterval(addValue, 50));

							setTimeout(function()
							{
								if (c == itemElement.data("mouseCounter"))
								{
									if ($(itemElement).data("interval"))	{ clearInterval($(itemElement).data("interval")); }

									itemElement.data("interval", setInterval(addValue, 10));
								}
							}, 500);
						}, 500);
					}
				}
			}).on("mouseup", function()
			{
				if (!$(this).parent().hasClass("swapartcod"))
				{
					var $this								= $(this);
					var itemElement							= $(this).parents(".item");
					var c									= itemElement.data("mouseCounter");

					itemElement.data("mousedown", false);

					if ($(itemElement).data("interval"))	{ clearInterval($(itemElement).data("interval")); }

					setTimeout(function()
					{
						if (c == itemElement.data("mouseCounter") && !itemElement.data("updating"))
						{
							itemElement.data("updating", true);

							var valueElement				= $this.parent().find(".value");
							var text						= valueElement.text();
							var value						= parseInt(text.left(" "));

							webshop.setLengte(itemElement.attr("data-rglid"), value, function(xmlDoc)
							{
								itemElement.data("updating", false);

								if ($(xmlDoc).find("success").length > 0)
								{
									webshop.fetchCart(updateCart);
								}
							});
						}
					}, 250);
				}
			}).on("click", function()
			{
				if ($(this).parent().hasClass("swapartcod"))
				{
					var itemElement							= $(this).parents(".item");

					if (!itemElement.data("updating"))
					{
						itemElement.data("updating", true);

						webshop.swapArtcod(itemElement.attr("data-rglid"), function(xmlDoc)
						{
							itemElement.data("updating", false);

							if ($(xmlDoc).find("success").length > 0)
							{
								webshop.fetchCart(updateCart);
							}
						});
					}
				}
			});
		}

		var landcodElem					= $("#landcodfield > select[name=landcod]");

		if (landcodElem.length > 0)
		{
			var landcodfieldc			= 0;

			landcodElem.on("change", function()
			{
				var c					= ++landcodfieldc;
				var value				= $(this).val();

				setTimeout(function()
				{
					if (landcodfieldc == c)
					{
						webshop.setLandcod(value, function(xmlDoc)
						{
							if ($(xmlDoc).find("success").length > 0)
							{
								webshop.fetchCart(updateCart);
							}
						});
					}
				}, 100);
			});

			$(window).on("beforeunload", function()
			{
				if (oldlandcod && landcodElem.val() != oldlandcod)
				{
					landcodElem.val(oldlandcod);
					webshop.setLandcod(oldlandcod);
				}
			});
		}

		$.ajax({
			url: "/product/switchable.json",
			type: "get",
			success: function(data, jqXHR, textStatus)
			{
				articlesWithAlternatives = data;
				webshop.fetchCart(updateCart);
			}
		});

		updateCarts = function(){ webshop.fetchCart(updateCart); };
	}

	if ($("#discountcode").length > 0)
	{
		$("#btnUseCode").on("click", function()
		{
			webshop.setDiscountCode($("#discountcode").val().toUpperCase(), function(xmlDoc)
			{
				if ($(xmlDoc).find("success").length > 0)
				{
					alert(translate_discount_applied + ".");
					window.location.reload(false);
				}
				else
				{
					alert(translate_discount_invalid + ".");
				}
			});
		});
	}
});

$(window).on("load", function()
{
	$("input.A2").on("keyup", function()
	{
		$(this).val($(this).val().toUpperCase());
	})
})

var webshop = {};

((function($)
{
	webshop.fetchCart = function(callback)
	{
		if (callback)
		{
			$.ajax({
				url: "/webshop",
				type: "get",
				data: { "action": "fetchCart" },
				success: function(xmlDoc, textStatus, jqXHR){ callback(xmlDoc); }
			});
		}
	};

	webshop.addToCart = function(gc1art_unid, aantal, callback, gc1artmagvrd_unid, refcod, json_params)
	{
		if (!gc1artmagvrd_unid)				{ gc1artmagvrd_unid = 0; }
		if (!refcod)						{ refcod = ""; }
		if (!json_params)					{ json_params = {}; }

		if (aantal == "" || isNaN(aantal) || JSO.toBigDecimal(aantal).compareTo(new BigDecimal("0.00")) <= 0)	{ ui.dialog.alert("Geef een geldig aantal op"); }
		else
		{
			$.ajax({
				url: "/BestelServlet",
				data: { "action": "addtocart", "uniqueid": gc1art_unid, "aantal": aantal, "gc1artmagvrd_unid" : gc1artmagvrd_unid, "refcod" : refcod, "json_params": JSON.stringify(json_params) },
				cache: false,
				type: "POST",
				success: function(xmlDoc, textStatus, jqXHR)
				{
					var errmsg									= $("error", $(xmlDoc)).text();

					if		(errmsg != "")						{ ui.dialog.alert(errmsg); }
					else if	(callback)							{ callback(xmlDoc); }
				}
			});
		}
	};

	webshop.updateCart = function(gc1offrgl_unid, gc1art_unid, aantal, refcod, callback, json_params)
	{
		if (!json_params)					{ json_params = {}; }

		if (aantal == "" || isNaN(aantal) || JSO.toBigDecimal(aantal).compareTo(new BigDecimal("0.00")) < 0)	{ ui.dialog.alert("Geef een geldig aantal op"); }
		else
		{
			$.ajax({
				url: "/BestelServlet",
				data: { "action": "update", "gc1offrgl_unid": gc1offrgl_unid, "gc1art_unid": gc1art_unid, "aantal": aantal, "refcod": refcod, "json_params": json_params },
				cache: false,
				type: "POST",
				success: function(xmlDoc, textStatus, jqXHR)
				{
					var errmsg									= $("error", $(xmlDoc)).text();

					if		(errmsg != "")						{ ui.dialog.alert(errmsg); }
					else if (callback)							{ callback(xmlDoc); }
				}
			});
		}
	};

	webshop.removeCartRgl = function(gc1offrgl_unid, gc1art_unid, callback)
	{
		ui.dialog.createModalDialog({
			title: getApplicationName(),
			html: "<p>Weet u zeker dat u de regel wilt verwijderen?</p>",
			width: 360,
			height: 200,
			closeOnEscape: true,
			closable: false,
			buttons:
			[
				{
					text: "Ja",
					click: function()
					{
						this.dialog("close");

						webshop.updateCart(gc1offrgl_unid, gc1art_unid, "0", "", callback);
					}
				},
				{
					text: "Nee",
					click: function()
					{
						this.dialog("close");
					}
				}
			]
		});
	};

	webshop.setDiscountCode = function(code, callback)
	{
		$.ajax({
			url: "/BestelServlet",
			type: "post",
			data: { "action": "discountcode", "code": code },
			success: function(xmlDoc, textStatus, jqXHR)
			{
				if (callback)								{ callback(xmlDoc); }
			}
		});
	};

	webshop.clearCart = function(callback)
	{
		ui.dialog.createModalDialog({
			title: getApplicationName(),
			html: "<p>Weet u zeker dat u de winkelwagen wilt leegmaken?</p>",
			width: 360,
			height: 200,
			closeOnEscape: true,
			closable: false,
			buttons:
			[
				{
					text: "Ja",
					click: function()
					{
						this.dialog("close");

						$.ajax({
							url: "/BestelServlet",
							type: "post",
							cache: false,
							data: { "action": "clear" },
							success: function(xmlDoc, textStatus, jqXHR)
							{
								if		(callback)								{ callback(xmlDoc); }
								else if ($("success", $(xmlDoc)).text() == "1")	{ location.reload(); }
							}
						});
					}
				},
				{
					text: "Nee",
					click: function()
					{
						this.dialog("close");
					}
				}
			]
		});
	};
})(jQuery));

